import React from 'react';

import { Container, ProgressContainer } from './styledComponents';

interface ProgressBarProps {
  completedBars: number;
  totalProgressBars: number;
}

export const ProgressBarWithSteps = (props: ProgressBarProps) => {
  const { completedBars, totalProgressBars } = props;

  const progressBarsArray: Array<string> = [];
  for (let i = 0; i < totalProgressBars; i++) {
    progressBarsArray.push('');
  }

  const renderProgressBars = () => {
    return progressBarsArray.map((arrayElement, index) => {
      const className =
        index < completedBars
          ? 'progress-bar-with-steps-completed'
          : 'progress-bar-with-steps';
      return (
        <ProgressContainer
          data-testid="progressBarWithSteps"
          key={index}
          isDone={index < completedBars}
          className={className}
        />
      );
    });
  };

  return (
    <Container
      data-testid="progressBarWithStepsContainer"
      className="progress-bar-with-steps-container"
    >
      {renderProgressBars()}
    </Container>
  );
};
